import React from 'react';

import { CheckCircle, Email } from '@mui/icons-material';

import * as S from './styles';
import Button from 'components/Button';
import Text from 'components/Text';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import GlobalModal from 'modals/GlobalModal/GlobalModal';
import { useIsMobile } from 'utils/mediaQueries';

interface EmailRecoveredModalProps {
  open: boolean;
  onClose: () => void;
  partialEmail: string;
  onReturnToLogin: (email: string) => void;
}

const EmailRecoveredModal: React.FC<EmailRecoveredModalProps> = ({
  open,
  onClose,
  partialEmail,
  onReturnToLogin,
}) => {
  const theme = useThemeContext();
  const isMobile = useIsMobile();

  const handleReturnToLogin = () => {
    // Extract full email if available, otherwise use partial
    // Try to reconstruct full email if user remembers it
    onReturnToLogin(partialEmail);
    onClose();
  };

  return (
    <GlobalModal
      title="E-MAIL RECUPERADO"
      open={open}
      onClose={onClose}
      width={isMobile ? '90%' : '550px'}
    >
      <S.Content>
        <S.SuccessIcon>
          <CheckCircle
            style={{
              fontSize: 60,
              color: theme.success || '#4caf50',
            }}
          />
        </S.SuccessIcon>

        <Text size="large" color="textPrimary" bold>
          E-mail localizado com sucesso!
        </Text>

        <S.EmailDisplay>
          <Email style={{ fontSize: 32, color: theme.primary || '#1976d2' }} />
          <Text size="small" color="textSecondary">
            Seu e-mail de cadastro é:
          </Text>
          <S.EmailText themeColors={theme}>{partialEmail}</S.EmailText>
        </S.EmailDisplay>

        <S.InstructionsContainer>
          <Text size="medium" color="textPrimary" bold>
            Próximos passos:
          </Text>

          <S.InstructionStep>
            <S.StepNumber themeColors={theme}>1</S.StepNumber>
            <S.StepContent>
              <Text size="small" color="textSecondary">
                Anote ou memorize seu e-mail de cadastro
              </Text>
            </S.StepContent>
          </S.InstructionStep>

          <S.InstructionStep>
            <S.StepNumber themeColors={theme}>2</S.StepNumber>
            <S.StepContent>
              <Text size="small" color="textSecondary">
                Clique no botão abaixo para voltar à tela de login
              </Text>
            </S.StepContent>
          </S.InstructionStep>

          <S.InstructionStep>
            <S.StepNumber themeColors={theme}>3</S.StepNumber>
            <S.StepContent>
              <Text size="small" color="textSecondary">
                Digite o e-mail recuperado e sua senha para acessar a plataforma
              </Text>
            </S.StepContent>
          </S.InstructionStep>
        </S.InstructionsContainer>

        <S.ButtonContainer>
          <Button
            type="button"
            variant="primary"
            fullWidth
            onClick={handleReturnToLogin}
          >
            Voltar para o Login
          </Button>
        </S.ButtonContainer>

        <div style={{ textAlign: 'center' }}>
          <Text size="small" color="textSecondary">
            Esqueceu sua senha? Recupere sua senha após inserir o e-mail no login.
          </Text>
        </div>
      </S.Content>
    </GlobalModal>
  );
};

export default EmailRecoveredModal;
